"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorFromProps = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const Wrapper = (0, styled_components_1.default)('span') `
  ${({ $color }) => $color &&
    (0, styled_components_1.css) `
      color: ${$color};
    `};
`;
function getColorFromProps(theme, props) {
    if (props.danger) {
        return theme.color.danger;
    }
    else if (props.success) {
        return theme.color.success;
    }
    else if (props.warning) {
        return theme.color.warning;
    }
    else if (props.faded) {
        return theme.color.fadedText;
    }
    else if (props.primary) {
        return theme.color.primary;
    }
    return 'inherit';
}
exports.getColorFromProps = getColorFromProps;
class Text extends React.PureComponent {
    render() {
        const _a = this.props, { color, primary, danger, success, warning, faded, theme } = _a, restProps = tslib_1.__rest(_a, ["color", "primary", "danger", "success", "warning", "faded", "theme"]);
        let textColor = '';
        if (color) {
            textColor = color;
        }
        else {
            textColor = getColorFromProps(theme, this.props);
        }
        return (React.createElement(Wrapper, Object.assign({ "$color": textColor }, restProps), this.props.children));
    }
}
Text.defaultProps = {
    className: '',
    children: null,
    primary: false,
    danger: false,
    success: false,
    warning: false,
    faded: false,
};
exports.default = (0, styled_components_1.withTheme)(Text);
